import { render } from "./FilteredStarups.vue?vue&type=template&id=52521d76"
import script from "./FilteredStarups.vue?vue&type=script&lang=js"
export * from "./FilteredStarups.vue?vue&type=script&lang=js"

import "./FilteredStarups.vue?vue&type=style&index=0&id=52521d76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__